import { AxiosInstance, CancelToken } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';

interface UploadImageOptions {
  onProgress?: (e: ProgressEvent) => void;
  cancelToken?: CancelToken;
}

export class UploadApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.uploadImage = this.uploadImage.bind(this);
  }

  public async uploadImage(
    file: File,
    { onProgress, cancelToken }: UploadImageOptions = {},
  ): ApiResult<{ url: string }> {
    const formData = new FormData();
    formData.append('image', file);

    const result = await this.post<{ url: string }>('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: onProgress,
      cancelToken,
    });

    return result;
  }
}
